import { render, staticRenderFns } from "./UserRoleView.vue?vue&type=template&id=42750dbc&scoped=true"
import script from "./UserRoleView.vue?vue&type=script&lang=js"
export * from "./UserRoleView.vue?vue&type=script&lang=js"
import style0 from "./UserRoleView.vue?vue&type=style&index=0&id=42750dbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42750dbc",
  null
  
)

export default component.exports